import {Move} from "../../js/helpers";
import {break_xl} from "../../js/constants";

new Move(document.querySelector('[data-move="orderSum-get"]'), document.querySelector('[data-move="orderSum-set"]'), break_xl).init();
new Move(document.querySelector('[data-move="orderSum-total-get"]'), document.querySelector('[data-move="orderSum-total-set"]'), break_xl).init();

(function () {

  if (window.innerWidth > break_xl) return;
  const orderPageTitle = document.querySelector('.order-page-title');
  const content = document.querySelector('.order-grid__content');

  if (!orderPageTitle) return;
  if (!content) return;

  content.insertBefore(orderPageTitle, content.firstChild);
})();
